import { createSelector } from '@reduxjs/toolkit';

import { getUser } from './getUser';

export const getUserPhone = createSelector(getUser, user => {
  const phone = user?.phones?.at(0)?.phone;

  return phone ? `+${phone}` : null;
});
